module.exports = __webpack_public_path__ + "static/media/Default_user_img.5739d04e.png";